import { render } from "./TemperatureCheck.vue?vue&type=template&id=13d11d84&ts=true"
import script from "./TemperatureCheck.vue?vue&type=script&lang=ts"
export * from "./TemperatureCheck.vue?vue&type=script&lang=ts"

import "./TemperatureCheck.vue?vue&type=style&index=0&id=13d11d84&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__